// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import Nope from 'app/components/common/Nope';
import * as services from 'app/common/constants/services';


type Props = {
  isGlolime: boolean,
}

const RestrictMessage = ({ isGlolime }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (
    <Nope
      service={services.APP_CAFETERIA}
      text={(isGlolime
        ? <span>
          {t('restrict_message_glolime', 'Информационный сервис по «Электронной столовой» в школе, где обучается Ваш ребенок, пока не предоставляется. В данный момент всю информацию о питании ребенка Вы можете посмотреть на')}
          {' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://petersburgedu.ru"
          >
            {t('restrict_message_glolime_link', 'Портале Петербургского Образования')}
          </a>
          {'.'}
        </span>
        : t('restrict_message', 'В школе ученика не предусмотрено использование приложения электронной столовой')
      )}
      header={t('restrict_message_header', 'Приложение недоступно в школе')}
    />
  );
};

export default RestrictMessage;
